import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserDoctor } from '@fortawesome/free-solid-svg-icons';
import './AIChatbot.css';

/**
 * Floating shortcut to the AI Family Doctor page. The consultation itself
 * (consent, records, voice) lives on /ai-family-doctor, so this button never
 * sends health data anywhere.
 */
const AIChatbot: React.FC = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { t } = useTranslation('familyDoctor');

  if (pathname.startsWith('/ai-family-doctor')) return null;

  return (
    <div className="ha-container">
      <button
        type="button"
        className="ha-toggle"
        onClick={() => navigate('/ai-family-doctor')}
        aria-label={t('title')}
        title={t('title')}
      >
        <FontAwesomeIcon icon={faUserDoctor} className="ha-toggle-icon" />
      </button>
    </div>
  );
};

export default AIChatbot;
